export default "__VITE_ASSET__DpQycwiP__"